// Used for login form and login API
export interface LoginCredentials {
  email: string;
  password: string;
} // recaptchaToken is not currently sent from the client

// Used for registration form and createUser API
export interface RegisterCredentials {
  firstName: string;
  lastName: string;
  email: string;
  countryCode: string;
  mobile: string;
  consentHealth: boolean;
  consentAge: boolean;
  consentFamily: boolean;
  selectedOption: number;
  inviteSelection?: "join" | "create";
  inviteToken?: string;
  dob?: string;
  gender?: number;
}

export interface AuthResponse {
  member: any;
  token: string;
  refreshToken?: string;
}

export interface RefreshTokenResponse {
  token: string;
  refreshToken?: string;
  message?: string;
  statusCode?: number;
}

export interface AuthState {
  member: any | null;
  token: string | null;
  error: string | null;
  isAuthenticated: boolean;
  loading: boolean;
  selectedMember: any | null;
}

// Navigation id to path mapping for post-login redirect
export const navIdToPath: Record<string, string> = {
  home: "/dashboard",
  documents: "/documents",
  reminders: "/reminders",
  insights: "/insights",
  family: "/profile/family",
};
